import React from "react";
import "../App.css";
import Fire from "../config/Fire";
//import {InfiniteLoading} from 'react-simple-infinite-loading'
import InfiniteScroll from 'react-infinite-scroll-component';
import RenderPost from "../utils/Post/RenderPost";
import Aux from "../utils/AuxFunctions";
import queryString from 'query-string'
import Colors from "../utils/Colors";
import InstagramIcon from "mdi-react/InstagramIcon"
import SnapchatIcon from "mdi-react/SnapchatIcon"
import TwitterIcon from "mdi-react/TwitterIcon"
import ProfileHeader from "../account/ProfileHeader";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
import SendMessage from "../utils/Utilities/SendRequestModal";
import NotLoggedIn from "../utils/ErrorPages/NotLoggedIn";
import { withMyDataContext } from "../context/DataProvider";
import Loader from "../utils/Utilities/Loader";

const LIMIT = 10;
const TYPE = "userPosts"
class ViewUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            postsData: [],
            lastVisible: null,
            finished: false,
            loading: false,
            username: this.props.match.params.username,
            user: {},
            userNotFound: false,
            sendingMessage: false,
            loginModal: false,
            loadingUser: false,
        }
    }
    username = "";

    componentDidMount = async () => {
        try{
            this.getUsername();
        }catch(error){
            Aux.handleError(error)
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.username !== prevProps.match.params.username) {
            this.clearUser();
            this.getUsername();
        }
    }

    clearUser = () => {
        this.username = "";
        this.setState({postsData: [], lastVisible: null, finished: false, loading:false, userNotFound: false, user: {}})
    }

    sendMessage = () => {
        if(this.props.myDataProvider.user){
            this.setState({sendingMessage:true})
        }else{
            this.setState({loginModal:true})
        }
    }

    /* sendRequest = async() => {
        try{
            if(this.state.user){
                console.log(this.state.user.uid)
                var sent = await Fire.shared.sendRequest(this.state.user.uid)
                if(sent){
                    console.log("request sent")
                }else{
                    console.log("request not sent")
                }
                
            }
            
        }catch(error){
            Aux.handleError(error)
        }
    } */

    getUsername = async() => {
        try {
            if (this.props.match.params.username) {
                await this.getUserInfo(false);
/*                 await this.getAllData(); */
            } else if (this.props.location.search) {
                const values = queryString.parse(this.props.location.search)
                await this.getUserInfo(true, values.id)
            }

        } catch (error) {
            Aux.handleError(error)
        }
    }

    getUserInfo = async (isId, id) => {
        try {
            var user = null;
            this.setState({loadingUser: true})
            if (isId) {
                user = await Fire.shared.getUserInfoUsername(id, true)
            } else {
                user = await Fire.shared.getUserInfoUsername(this.props.match.params.username, false)
            }
            this.setState({loadingUser: false})
            if (user) {
                this.setState({ user: user })
                this.username = user.username;
                await this.getAllData();
            } else {
                this.setState({ userNotFound: true })
            }
            
        } catch (error) {
            this.setState({loadingUser: false})
            Aux.handleError(error)
        }
    }

    getAllData = async () => {
        if (this.state.loading) return;

        try {
            this.setState({ loading: true })
            const user = this.username ? this.username : this.props.match.params.username
            Fire.shared
                .GetPostsData(TYPE, this.state.lastVisible, LIMIT, user)
                .then(snapshot => {
                    if (snapshot) {

                        if (snapshot.length < LIMIT || snapshot.empty) {
                            this.setState({ finished: true })
                        }

                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            
                            return doc;
                        });
                        console.log(data)
                        this.setState({
                            postsData: [...this.state.postsData, ...data],
                            lastVisible: snapshot.docs[snapshot.docs.length - 1],
                            loading: false,
                        });

                    } else {
                        this.setState({ finished: true, loading: false })
                    }
                });
        } catch (error) {
            Aux.handleError(error)
        }
    };

    newProfileHeader = () => {
        return (
            <div style={{ marginTop: 30, margin:10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex" }}>
                        {Aux.showAvatar(75, this.state.user.avatar, this.state.user.username || "Unknown")}
                        <div style={{ display: "flex", flexDirection: "column", marginLeft: 20 }} >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div>
                                    <span style={{ fontSize: 18, fontWeight: "600", color: "black", margin: "3px 0px", }}>
                                        {this.state.user.username || "loading..."}
                                    </span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <div onClick={this.sendMessage} style={{ backgroundColor: "#e5e5e5", padding: "10px 20px", borderRadius: 10, border:"2px solid", borderColor: Colors.mainColor, display: "flex", }}>
                                        <span style={{ alignSelf: "center", fontSize: 15, fontWeight: "300" }}>Message</span>
                                        <ChevronRightIcon></ChevronRightIcon>
                                    </div>
                                    
                                    <div style={{ backgroundColor: "#e5e5e5", padding: "10px 20px", borderRadius: 10, display: "flex", }}>
                                        <span style={{ alignSelf: "center", fontSize: 15, fontWeight: "300" }}>Posts</span>
                                        <span style={{ alignSelf: "center", color: Colors.darkText, fontSize: 18, fontWeight: "bold", marginLeft: 20 }}>{this.state.user.postsCount || 0}</span>
                                    </div>

                                    <div style={{ backgroundColor: "#e5e5e5", padding: "10px 20px", borderRadius: 10, display: "flex", marginLeft: 30, }}>
                                        <span style={{ alignSelf: "center", fontSize: 15, fontWeight: "300" }}>Total Spent</span>
                                        <span style={{ alignSelf: "center", color: Colors.darkText, fontSize: 18, fontWeight: "bold", marginLeft: 20 }}>${this.state.user.coinsSpent || 0}</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                {this.state.user.name ? <span style={{ fontSize: 16, fontWeight: "500", margin: "3px 0px", }}>
                                    {this.state.user.name}
                                </span> : null}
                                {this.state.user.bio ?
                                    <span style={{ margin: "3px 0px", wordBreak: "break-all" }}>
                                        {this.state.user.bio}
                                    </span> : null}
                                {this.state.user.website ?
                                    <span style={{ color: Colors.link, }} onPress={this.openWebsite}>
                                        {this.state.user.website}
                                    </span> : null}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="prof-social-section">
                    {this.state.user.instagram ? (
                        <div className="prof-social-wrapper"
                            onClick={this.openInstagramProfile}>
                            <InstagramIcon className="prof-social-icon" name="instagram" size={25} />
                            <span className="prof-social-text" >{this.state.user.instagram}</span>
                        </div>) : null}
                    {this.state.user.twitter ? (
                        <div className="prof-social-wrapper"
                            onClick={this.openTwitterProfile}>
                            <TwitterIcon className="prof-social-icon" name="twitter" size={25} />
                            <span className="prof-social-text" >{this.state.user.twitter}</span>
                        </div>) : null}
                    {this.state.user.snapchat ? (
                        <div className="prof-social-wrapper"
                            onClick={this.openSnapchatProfile}>
                            <SnapchatIcon className="prof-social-icon" name="snapchat" size={25} />
                            <span className="prof-social-text" >{this.state.user.snapchat}</span>
                        </div>) : null}
                </div>

                <div style={{ borderBottom: "1px solid #ccc" }} />
            </div>
        )
    }

    render() {
        return (
            <div className="content-home" style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom:30 }}>
                {this.state.userNotFound ? 
                    <div style={{display:"flex", justifyContent:"center", marginTop:20}}>
                        <span>No user was found...</span>
                    </div> :
                this.state.loadingUser ? 
                    <div style={{display:"flex", justifyContent:"center", marginTop:20}}>
                        <Loader></Loader>
                    </div> :
                <div>
                <SendMessage active={this.state.sendingMessage} onClose={() => this.setState({sendingMessage:false})} user={this.state.user}></SendMessage>
                <ProfileHeader user={this.state.user} sendMessage={this.sendMessage}></ProfileHeader>
                <NotLoggedIn active={this.state.loginModal} onClose={() => this.setState({loginModal:false})}></NotLoggedIn>
                <InfiniteScroll
                    dataLength={this.state.postsData.length}
                    next={this.getAllData}
                    hasMore={!this.state.finished}
                    scrollableTarget="sideBar"
                    loader={<div style={{marginTop:20}}><Loader color={"#999"}></Loader></div>}
                    endMessage={
                        <div style={{marginTop:20}}>
                            {this.state.postsData.length <= 0 ?
                            <p style={{ textAlign: 'center' }}>
                                <b>there are no posts yet.</b>
                            </p>
                            :
                            <p style={{ textAlign: 'center' }}>
                                <b>You have seen it all.</b>
                            </p>}
                        </div>
                    }
                >
                    {this.state.postsData.map((item, index) => (
                        <RenderPost post={item} key={item.id + index} styles={this.props.styles}></RenderPost>
                    ))}
                </InfiniteScroll>
                </div>}
            </div>
        );
    }
}

export default withMyDataContext(ViewUser);
